/* istanbul ignore file */

import React from 'react';

import * as styles from './Footer.styles';
import { FooterAppPromo } from 'client-site-chrome-ui/components/molecules/FooterAppPromo/FooterAppPromo';
import { FooterLegal } from 'client-site-chrome-ui/components/molecules/FooterLegal/FooterLegal';
import { FooterLinks } from 'client-site-chrome-ui/components/molecules/FooterLinks/FooterLinks';
import { FooterPayment } from 'client-site-chrome-ui/components/molecules/FooterPayment/FooterPayment';
import { FooterSocialMedia } from 'client-site-chrome-ui/components/molecules/FooterSocialMedia/FooterSocialMedia';
import { LocalePanel } from 'client-site-chrome-ui/components/molecules/LocalePanel/LocalePanel';
import { NewsletterSignUpForm } from 'client-site-chrome-ui/components/molecules/NewsletterSignUpForm/NewsletterSignUpForm';
import { useSiteChromeStaticContext } from 'client-site-chrome-ui/context/SiteChromeStaticContext/useSiteChromeStaticContext';

export const Footer = () => {
  const { env } = useSiteChromeStaticContext();

  return (
    <footer>
      <section css={[styles.footerSections, styles.firstSection]}>
        <NewsletterSignUpForm env={env} />
      </section>
      <section css={[styles.footerSections, styles.secondSection]}>
        <div css={styles.footerInner}>
          <div css={styles.appSection}>
            <div css={styles.appContainer}>
              <FooterAppPromo />
            </div>
            <FooterSocialMedia />
          </div>
          <FooterLinks />
          <div css={styles.paymentSection}>
            <div css={styles.localePanel}>
              <LocalePanel
                buttonStyles={styles.localePanelButton}
                flagStyles={styles.localePanelFlag}
                headingStyles={styles.localePanelHeading}
                placement="footer"
              />
            </div>
            <FooterPayment />
          </div>
        </div>
      </section>
      <section css={[styles.footerSections, styles.thirdSection]}>
        <div css={styles.footerInner}>
          <FooterLegal />
        </div>
      </section>
    </footer>
  );
};
